/**
 * Add your config changes here.
 * @module config
 * @example
 * export default function applyConfig(config) {
 *   config.settings = {
 *     ...config.settings,
 *     port: 4300,
 *     listBlockTypes: {
 *       ...config.settings.listBlockTypes,
 *       'my-list-item',
 *    }
 * }
 */

import {
  //   settings as defaultSettings,
  //   views as defaultViews,
  widgets as widgetMapping,
  //   blocks as defaultBlocks,
  //   addonReducers as defaultAddonReducers,
  //   addonRoutes as defaultAddonRoutes,
} from '@plone/volto/config';

import TokenWidget from '@plone/volto/components/manage/Widgets/TokenWidget';
import DefaultView from '@plone/volto/components/theme/View/DefaultView';
import OsmapView from '@package/components/Blocks/Osmap/View';
import OsmapEdit from '@package/components/Blocks/Osmap/Edit';
import navigationSVG from '@plone/volto/icons/navigation.svg';

import FilmsTemplate from '@package/components/Blocks/Listing/FilmsTemplate';
import { FilmView } from '@package/components';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

import '@plone/volto/config';

export default function applyConfig(config) {
  // Load icons
  library.add(fab, faEnvelope);

  // Add here your project's configuration here by modifying `config` accordingly
  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,
    listing: {
      ...config.blocks.blocksConfig.listing,
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'filmsTemplate',
          isDefault: false,
          title: 'Lista di film',
          template: FilmsTemplate,
        },
      ],
    },
    osMap: {
      id: 'osMap',
      title: 'os map',
      icon: navigationSVG,
      group: 'homepage',
      view: OsmapView,
      edit: OsmapEdit,
      restricted: false,
      mostUsed: true,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },
  };

  config.settings.supportedLanguages = ['it'];
  config.settings.defaultLanguage = 'it';

  config.views.contentTypesViews.Film = FilmView;

  config.widgets.id = {
    ...config.widgets.id,
    rassegna: TokenWidget,
  };

  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    'News Item': DefaultView,
  };
  config.settings['volto-gdpr-privacy'] = {
    defaultPanelConfig: {
      ...config.settings['volto-gdpr-privacy'].defaultPanelConfig,
      last_updated: '2022-06-01T11:40:00+00:00',
    },
  };
  return config;
}
